import { c as _c } from "react/compiler-runtime";
import { CardShared } from '@/app/components/card/shared';
import { NEWS_ACTIVITIES_BASE_URL, NEWS_ACTIVITIES_EVENT_NAME } from '@/app/lcv/components/sections/news-activities/tracking';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import type { LcvNewsDetail } from '@/types/tis-cms/types';
interface NewsCardProps {
  news: LcvNewsDetail;
  index: number;
  eventName?: string;
}
export const NewsCard = t0 => {
  const $ = _c(25);
  const {
    news,
    index,
    eventName: t1
  } = t0;
  const eventName = t1 === undefined ? NEWS_ACTIVITIES_EVENT_NAME : t1;
  const category = news.category;
  if (!category?.url || !news.url) {
    return null;
  }
  const href = `${NEWS_ACTIVITIES_BASE_URL}/${category.url}/${news.url}`;
  const categoryUrl = `${NEWS_ACTIVITIES_BASE_URL}/${category.url}`;
  const t2 = news.title ?? "";
  const t3 = index <= 1;
  const t4 = news.thumbnail?.url ?? "";
  const t5 = news.thumbnail?.alternativeText ?? news.title ?? "";
  let t6;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      crop: "16:9"
    };
    $[0] = t6;
  } else {
    t6 = $[0];
  }
  let t7;
  if ($[1] !== t3 || $[2] !== t4 || $[3] !== t5) {
    t7 = {
      priority: t3,
      rootMargin: "10% 0px 0px 0px",
      loadedEffect: "fade",
      placeholder: "shimmer",
      src: t4,
      alt: t5,
      width: 312,
      height: 176,
      aspectRatio: "aspect-16-9",
      sizes: "(min-width: 768px) 46vw, 90vw",
      srcSetOptions: t6
    };
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const t8 = news.beginDate as string;
  let t9;
  if ($[5] !== t8) {
    t9 = {
      startDate: t8
    };
    $[5] = t8;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  const t10 = news.title ?? "";
  let t11;
  if ($[7] !== eventName || $[8] !== href || $[9] !== index || $[10] !== t10) {
    t11 = {
      click: true,
      text: t10,
      eventName,
      value: index,
      url: href
    };
    $[7] = eventName;
    $[8] = href;
    $[9] = index;
    $[10] = t10;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== category || $[13] !== categoryUrl) {
    t12 = category && {
      tag: {
        label: category.title ?? "",
        href: categoryUrl
      }
    };
    $[12] = category;
    $[13] = categoryUrl;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  const t13 = `news-card-${index}`;
  let t14;
  if ($[15] !== t13) {
    t14 = createDataAttributes({
      test: t13
    });
    $[15] = t13;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] !== href || $[18] !== t11 || $[19] !== t12 || $[20] !== t14 || $[21] !== t2 || $[22] !== t7 || $[23] !== t9) {
    t15 = <CardShared href={href} title={t2} image={t7} date={t9} dataGA={t11} {...t12} {...t14} />;
    $[17] = href;
    $[18] = t11;
    $[19] = t12;
    $[20] = t14;
    $[21] = t2;
    $[22] = t7;
    $[23] = t9;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  return t15;
};